<div class="container-fluid">
    <div class="row justify-content-center my-2">

        <div class="col-6 d-flex justify-content-center">
            <mat-form-field class="w-100">
                <mat-label>Sampling Point Code</mat-label>
                <input matInput placeholder="Sampling Point Code" [(ngModel)]="SearchText" (keyup.enter)="getLotListByFilter()">
            </mat-form-field>
        </div>
        <button appPreventDoubleClick class="col-auto m-2" mat-raised-button color="primary" (throttledClick)="getLotListByFilter()">
            Rechercher
        </button>
        <button appPreventDoubleClick matTooltip="Ajouter une nouvelle carte" class="col-auto m-2" mat-mini-fab color="accent" (throttledClick)="openMultipleUploadDialog()">
            <mat-icon>add</mat-icon>
        </button>
    </div>

    <div class="row justify-content-center">
        <div class="col-12 col-md-4 col-xl-2 my-2" *ngFor="let a of CarteList">
            <div class="h-100 m-3">
                <div class="row  border rounded-1 background-light h-100" style="border-width: 2px !important; border-bottom: 10px solid !important;">
                    <div class="col">
                        <div class="row justify-content-center ms-1 p-2 h-50">
                            {{a.SamlingPointCode}}
                        </div>

                        <div class="row justify-content-end">
                            <button class="col-auto" appPreventDoubleClick mat-icon-button color="warn" (throttledClick)="deleteLot(a)">
                                <mat-icon>delete</mat-icon>
                            </button>

                            <button class="col-auto" appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="getDocumentFile(a.DocumentCode)">
                                <mat-icon>get_app</mat-icon>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
